import styled from "styled-components";
import { Flex } from "discover.medical.react-component-library";

export const MediaTabContainer = styled(Flex)`
  width: 100%;
  justify-content: center;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    justify-content: flex-start;
  }
`;
export const MediaTabCell = styled(Flex)`
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 33.33%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 20%;
  }
  margin-top: ${({ theme }) => theme.space.md};
`;
